import React, { useState } from 'react';
import { FaPrint, FaUndo, FaSpinner } from 'react-icons/fa';
import axios from '../../../utils/axios';
import { toast } from 'react-hot-toast';

const ActionButtons = ({ 
    loading, 
    language, 
    handlePrintReceipt, 
    setShowConfirmation,
    order
}) => {
    const [checkingStatus, setCheckingStatus] = useState(false);
    
    // Function to check order status before showing confirmation
    const handleReturnClick = async () => {
        if (!order || !order.id) return;
        
        setCheckingStatus(true);
        try {
            // Extract numeric ID from order_number or use the original ID
            const orderId = order.id.toString().startsWith('ORD') 
                ? order.id.replace('ORD', '').replace(/^0+/, '')
                : order.id;
            
            // Determine if this is a card order
            const identifierStr = String(order.order_number || order.id || '');
            const isCardOrder = order.payment_method === 'card' ||
                              identifierStr.includes('CARD') ||
                              identifierStr.includes('card') ||
                              /^9\d{6,}$/.test(identifierStr) ||
                              /^ORD9/.test(identifierStr);
            
            // Check order status via API
            const response = await axios.get(`orders/${orderId}/status`, {
                params: { order_type: isCardOrder ? 'card' : 'cash' }
            });
            
            // Check if the order is already returned
            if (response.data && response.data.status === 'returned') {
                toast.error(
                    language === 'ar'
                        ? 'تم إرجاع هذا الطلب مسبقاً'
                        : 'This order has already been returned'
                );
                return;
            }
            
            // If not returned, show confirmation dialog
            setShowConfirmation(true);
            
        } catch (err) {
            console.error('Error checking order status:', err);
            // If we can't check the status, still allow the return attempt
            // The backend will validate again during the actual return
            setShowConfirmation(true);
        } finally {
            setCheckingStatus(false);
        }
    };
    return (
        <div className="flex space-x-2 rtl:space-x-reverse mt-4">
            <button
                onClick={() => handlePrintReceipt(false)}
                disabled={loading}
                className="flex-1 inline-flex justify-center items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50"
            >
                {(loading || checkingStatus) ? (
                    <FaSpinner className="animate-spin h-5 w-5" />
                ) : (
                    <>
                        <FaPrint className={language === 'ar' ? 'ml-2' : 'mr-2'} />
                        {language === 'ar' ? 'طباعة الإيصال' : 'Print Receipt'}
                    </>
                )}
            </button>
            <button
                onClick={handleReturnClick}
                disabled={loading || checkingStatus}
                className="flex-1 inline-flex justify-center items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 disabled:opacity-50"
            >
                {(loading || checkingStatus) ? (
                    <FaSpinner className="animate-spin h-5 w-5" />
                ) : (
                    <>
                        <FaUndo className={language === 'ar' ? 'ml-2' : 'mr-2'} />
                        {language === 'ar' ? 'إرجاع الطلب' : 'Return Order'}
                    </>
                )}
            </button>
        </div>
    );
};

export default ActionButtons;
